import { render } from "./GrammarTableDetail.vue?vue&type=template&id=dc4ea152&scoped=true"
import script from "./GrammarTableDetail.vue?vue&type=script&lang=js"
export * from "./GrammarTableDetail.vue?vue&type=script&lang=js"

import "./GrammarTableDetail.vue?vue&type=style&index=0&id=dc4ea152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4ea152"]])

export default __exports__